/*
 * MMC: other colors of a product (sections/suit-related-products.liquid, "color" source).
 *
 * All colors of an article share suit.product_name, which is also the prefix of the variant SKUs. The predictive search
 * on variants.sku returns them, rendered with the Suit product cards by sections/suit-color-variants.liquid (which keeps
 * only exact suit.product_name matches). The current product is removed; the carousel stays hidden when nothing is left.
 */
(() => {
  const loadColorVariants = async (container) => {
    const term = container.dataset.suitColorVariants;
    const carousel = container.querySelector('scroll-carousel');

    if (!term || !carousel || container.dataset.loaded) {
      return;
    }

    container.dataset.loaded = 'true';

    const params = new URLSearchParams({
      q: term,
      'resources[type]': 'product',
      'resources[limit]': '10',
      'resources[options][fields]': 'variants.sku',
      'resources[options][unavailable_products]': 'hide',
      section_id: 'suit-color-variants',
    });

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}search/suggest?${params}`);

      if (!response.ok) {
        return;
      }

      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const cards = [...html.querySelectorAll('.suit-color-variants product-card')]
        .filter((card) => card.getAttribute('handle') !== container.dataset.currentHandle);

      if (cards.length === 0) {
        return;
      }

      carousel.replaceChildren(...cards.map((card) => document.importNode(card, true)));
      container.hidden = false;
    } catch (error) {
      // Network error: the "other colors" carousel simply stays hidden
    }
  };

  document.querySelectorAll('[data-suit-color-variants]').forEach(loadColorVariants);
})();
